import { render } from "./Account.vue?vue&type=template&id=6d01c154"
import script from "./Account.vue?vue&type=script&lang=ts"
export * from "./Account.vue?vue&type=script&lang=ts"
script.render = render

export default script